import React from 'react'
import { Modal } from 'antd'
import { useIntl } from 'react-intl'

import IntlMessages from '../../../../util/IntlMessages'
import ForceChangePasswordModal from '../../../../components/modal-force-change-password'
import { ISigninModals } from '../hooks/use-signin-modals'

export interface ISigninModalsProps {
  modals: ISigninModals
  onRetrySlackWithFullScopes: () => void
  onSaveNewPassword: (password: string) => Promise<void>
  onCancelNewPassword: () => void
}

/** Every modal the sign-in page can raise. They portal to the body, so order is free. */
const SigninModals = ({ modals, onRetrySlackWithFullScopes, onSaveNewPassword, onCancelNewPassword }: ISigninModalsProps): React.ReactElement => {
  const { formatMessage } = useIntl()
  const { state } = modals

  return (
    <>
      {state.slackLoginRequired && (
        <Modal
          title={formatMessage({ id: 'error.slack.usersLoginRequiredTitle' })}
          open={state.slackLoginRequired}
          onOk={onRetrySlackWithFullScopes}
          cancelText={formatMessage({ id: 'app.cancel' })}
          okText={formatMessage({ id: 'connect.slack.usersLoginRequiredButton' })}
          onCancel={() => modals.showSlackLoginRequired(false)}
        >
          <p>
            <IntlMessages id="connect.slack.usersLoginRequiredDescription1" />
          </p>
        </Modal>
      )}

      {state.forceChangePassword && <ForceChangePasswordModal onSave={onSaveNewPassword} onCancel={onCancelNewPassword} isLoading={state.forceChangePasswordLoading} />}
    </>
  )
}

export default SigninModals
